import React, { FunctionComponent } from 'react';

import { FitnessActivity } from '../../../../types/__generated__';
import ShareButton from '../ShareButton/ShareButton';
import { StravaLink } from '../StravaTimelineEntry/StravaLink';

import styles from '../Timeline.scss';

interface FooterProps {
  fitnessActivity?: FitnessActivity | null;
  message?: string | null;
  media: any;
}

export const Footer: FunctionComponent<FooterProps> = ({
  fitnessActivity,
  media,
  message,
}) => {
  const activityId = fitnessActivity?.activityId;

  return (
    <div className={`${styles.actionsContainer} jg-flex-jcb`}>
      <ShareButton timelineImage={media?.[0]?.url} description={message} />
      {activityId && <StravaLink activityId={activityId} />}
    </div>
  );
};

Footer.displayName = 'TimelineEntryFooter';
